<template>
  <div class="fixed white pt-2 elevation-6">
    <div class="mb-4 text-center">
      <!-- <span class="chip">chip</span> -->
    </div>
    <div class="text-right mx-4 success--text text--darken-2 d-flex justify-center">
      <p class="contained success lighten-3 pa-4 rounded text-left">
        {{ explanation }}
      </p>
    </div>

    <div class="bottom-next d-flex align-end">
      <div>
        <v-avatar
          class="image-corner"
          size="120"
          tile
        >
          <v-img
            src="@/assets/img/game-avatars/06.png"
          />
        </v-avatar>
      </div>
      <div class="pr-4 bottom-next__buttons contained">
        <v-btn
          v-if="source && $i18n.locale === 'es'"
          block
          large
          rounded
          outlined
          :href="source"
          color="success darken-1"
          target="_blank"
          @click="$track('view_source', 'cards')"
        >
          {{ $t('GAME.CARDS.WRONG.READ_MORE') }}
        </v-btn>
        <v-btn
          block
          large
          rounded
          depressed
          class="my-2 success--text text--darken-2 bold"
          @click="$emit('resume')"
        >
          {{ $t('GAME.CARDS.WRONG.RESUME') }}
        </v-btn>
      </div>
    </div>
  </div>
</template>

<style scoped>
.fixed {
  left: 0;
  position: fixed;
  bottom: 0;
  width: 100vw;
  z-index: 10;
}

.contained {
  max-width: 500px;
}

.title {
  text-shadow: 0px 0px 15px rgba(0, 0, 0, .24);
  position: relative;
}
  .title * {
    z-index: 2;
  }

  .title .bg-icon {
    position: absolute;
    left: -35px;
    top: -82px;
    opacity: .4;
    text-shadow: none;
    z-index: 1;
  }

.bottom-next,
.bottom-next__buttons {
  width: 100%;
}

.bottom-next__buttons {
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
}

@media screen and (min-width: 620px) {
  .bottom-next__buttons {
    margin: auto;
    margin-right: calc(50% - 250px);
  }
}
</style>

<script>
export default {
  name: 'CardsErrorTrue',
  props: {
    explanation: {
      type: String,
      default: '',
    },
    source: {
      type: String,
      default: '',
    },
  },
};
</script>
